// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M11 2H2V11H11V2Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M2 13V22H11V13H2Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M13 22H22V2H13V22Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-component-layout-filled')
export default class ComponentLayoutFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'component-layout-filled',
    }
  }
}
